import script from "./AddressView.vue?vue&type=script&setup=true&lang=js"
export * from "./AddressView.vue?vue&type=script&setup=true&lang=js"

import "./AddressView.vue?vue&type=style&index=0&id=91ca2c14&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-91ca2c14"]])

export default __exports__